<template>
<div class="chapter">
<div class="inner_page">
<div class="chapter" id="ch02">
<a id="page2">
<div class="chapterHead">
<h2 class="chapterTitle"> </h2></div>
<div class="chapterBody">
<p class="chapterOpenerText"><span class="chapterOpenerFirstWords"><span class="bold">Want to know what’s better</span></span> than having it all? Way, way better?</p>
<p class="spaceBreak"> </p>
<p class="paraCenter">Not having it all, but knowing of its inevitability, in a never-ending adventure that’s just barely begun.</p>
<p class="spaceBreak"> </p>
<p class="paraCenter">Yeeeeeehaaaaaaaaaaaaaaa!</p>
<p class="spaceBreak"> </p>
<p class="paraCenter"><em class="italic">Kind of like Friday just before the weekend.</em></p>
</div>
</a></div><a id="page2">
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781416594161_ch02.vue?1db65a13